// Analytics service — stream metrics, server errors (unchanged)
export const ENVIRONMENTS = {
  DEV: 'http://localhost:8080',
  PROD: 'https://ftvtags.azurewebsites.net',
};

// FTV backend — platform service health only (/health), not stream data
export const SERVICE_HEALTH_ENVIRONMENTS = {
  DEV: 'http://localhost:5000',
  PROD: 'https://agtv-2020.el.r.appspot.com',
};

export const ACTIVE_ENV = 'PROD';

export const STREAM_HEALTH_PATH = '/api/monitoring/stream-health';
export const SERVER_ERRORS_PATH = '/api/monitoring/server-errors';
export const SERVICE_HEALTH_PATH = '/health';

export const getBaseUrl = () => {
  return (ENVIRONMENTS[ACTIVE_ENV] || ENVIRONMENTS.DEV).replace(/\/+$/, '');
};

const getServiceHealthBaseUrl = () => {
  return (SERVICE_HEALTH_ENVIRONMENTS[ACTIVE_ENV] || SERVICE_HEALTH_ENVIRONMENTS.DEV).replace(/\/+$/, '');
};

export const getStreamHealthUrl = () => {
  return `${getBaseUrl()}${STREAM_HEALTH_PATH}`;
};

export const getServiceHealthUrl = () => {
  return `${getServiceHealthBaseUrl()}${SERVICE_HEALTH_PATH}`;
};

export const getServerErrorsUrl = () => {
  return `${getBaseUrl()}${SERVER_ERRORS_PATH}`;
};
